import React from 'react';
import styled from 'styled-components';

const Svg = styled.svg`
  width: 22px;
  flex: 0 0 22px;
  height: 18px;
  margin-right: 9px;

  @media (min-width: 768px) {
    width: 32px;
    flex: 0 0 32px;
    height: 26px;
    margin-right: 15px;
  }
`;

const SpeechMarks = () => (
  <Svg viewBox="0 0 46 36.1">
    <path
      d="M20.7 27.9c0 4.3-4 8.2-8.9 8.2C3.6 36.1 0 30 0 21.9 0 12.7 9.3 3.7 17.8 0l2.3 3.6c-7 3.4-12.2 8-13 15.7H10c3.1 0 6.3.5 8.5 2.7 1.5 1.6 2.2 3.7 2.2 5.9zm25.3 0c0 4.3-4 8.2-8.9 8.2-8.2 0-11.7-6.1-11.7-14.1 0-9.3 9.3-18.2 17.8-21.9l2.3 3.6c-7 3.4-12.2 8-13 15.7 3.2 0 5.8-.1 8.1.7 3.6 1.2 5.4 4 5.4 7.8z"
      fill="#4eb18a"
    />
  </Svg>
);

export default SpeechMarks;
